var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBird(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 397 411.5",
    id: "Layer_1",
    viewBox: "0 0 397 411.5",
    x: "0px",
    xmlSpace: "preserve",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "change1_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m394.9 401.2c-2.3 2.2-4.4 3.2-6.7 3.2-1.6 0-3.1-0.5-4.5-1-1.5-0.5-3-1-4.7-1-1.9 0-3.9 0.7-6.1 2-5.4 3.4-11.9 7.1-20.5 7.1-9 0-19-3.9-30.4-12.1-2.1-1.5-4.1-2.2-6.3-2.2-1.3 0-2.5 0.2-3.8 0.4-1.4 0.2-2.9 0.5-4.5 0.5-3.7 0-7.2-1.4-11-4.3-18.5-14.2-38.1-20.8-58.6-25-10.9-2.2-22-3.6-33.4-5.1-38.6-5.1-78.5-10.3-121.4-43.3-36.5-28.1-43.7-52.2-48.5-68.2-0.5-1.7-1-3.3-1.4-4.7-3.2-9.8-5.5-14.7-7.7-17.2-0.3-0.4-0.7-0.7-1-1-0.8-0.7-1.6-1.1-2.4-1.4-2.3-0.8-8.1-3.1-13.1-5.2-3.6-1.4-6.6-2.7-7.5-3-1.3-0.4-1.4-1.2-1.4-1.6s0.1-1.4 3.3-2.2c2.8-0.9 10.3-4 12.3-6.9 0.2-0.3 0.5-0.8 0.8-1.5l0.6-1.2c3.8-7.5 12.6-25 30.5-25 2.8 0 5.8 0.4 8.8 1.3 16.8 4.9 24.9 16.1 30.8 24.2 3.4 4.7 6.1 8.4 9.1 9 0.9 0.2 1.8 0.3 2.6 0.3 2.9 0 4.5-1.1 4.8-3.3 1.1-8.1 0.9-18.2 0.6-28.9-0.4-17.7-1-37.8 4.9-53.6 9.6-25.7 31-46.4 48.3-63 4.3-4.2 8.4-8.1 11.9-11.7 1.3-1.7 2.7-3.2 4.1-4.6 2-2.1 3.8-4.1 5.2-6.2 5.8-9 9.8-19.2 13.3-28.9 0.3-1.1 0.7-2.1 1-3.2 0.5-1.7 1.1-3 1.8-4 1.9-4.6 4.2-8.8 7.6-8.8 0.5 0 1.1 0.1 1.6 0.3 6 2.3 7.3 14.6 8.4 25.5 0.6 5.6-11.9 169.6-17.2 173.9 14.7-6.7 40.5-44.3 70.3-50.4 37-7.6 74.8-12.8 94.2-20.6 9.2-3.7 14.6-6.6 18.6-7.3 2.6-0.4 4 2 2.7 5.3-2.8 7.1-37.4 62.4-65.7 96.1-20.4 24.3-59.5 65.1-92.8 65.1-2 0-3.9-0.1-5.8-0.4 13.2 13.7 61.3 49.7 103.9 67.4 51.5 21.4 74.7 32.3 76.4 40.9 0.4 2-0.3 3.9-2 5.5z",
    fill: "#0F3EB5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "change2_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m237.7 368.7c-10.9-2.2-22-3.6-33.4-5.1-38.6-5.1-79.2-9.5-121.4-43.3-41.9-33.7-43.7-52.3-48.5-68.3-0.5-1.7-1-3.3-1.4-4.7-3.2-9.8-5.8-13.9-8.6-18.2 13.6 4.5 62.9 23 82.4 50.9 34.7 49.7 86.7 73.1 130.9 88.7z",
    fill: "#F4A6BE"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "change3_1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39.2,
    cy: 206.1,
    fill: "#fff",
    r: 4.6
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "change4_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24.4 229.3c-0.8-0.7-1.6-1.1-2.4-1.4-2.3-0.8-8.1-3.1-13.1-5.2-3.6-1.4-6.6-2.7-7.5-3-1.3-0.4-1.4-1.2-1.4-1.6s0.1-1.4 3.3-2.2c2.8-0.9 10.3-4 12.3-6.9 0.2-0.3 0.5-0.8 0.8-1.5-0.4 4.1 8 21.8 8 21.8z",
    fill: "#EA4524"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBird);
export default __webpack_public_path__ + "static/media/bird.224782d1579a91d795d0027d8f070b4b.svg";
export { ForwardRef as ReactComponent };